import { Children, isValidElement } from 'react';
import xss from 'xss';
import type { ReactNode } from 'react';

export const reactNodeToSanitizedText = (node: ReactNode): string => {
    if (typeof node === 'string' || typeof node === 'number') {
        return xss(String(node));
    }

    if (!node || typeof node === 'boolean') {
        return '';
    }

    if (isValidElement(node)) {
        const props = node.props as { children?: ReactNode };
        const children = Children.toArray(props.children ?? null);
        return children
            .map((child) => reactNodeToSanitizedText(child))
            .join(' ')
            .replace(/\s+/g, ' ');
    }

    return '';
};
